export const BANKDETAILS = "DESIGNATION";
export const BANKDETAILS_SUCCESS = "BANKDETAILS_SUCCESS";
export const BANKDETAILS_FAILED = "BANKDETAILS_FAILED";

export const ADD_BANKDETAILS = "ADD_BANKDETAILS";
export const ADD_BANKDETAILS_SUCCESS = "ADD_BANKDETAILS_SUCCESS";
export const ADD_BANKDETAILS_FAILED = "ADD_BANKDETAILS_FAILED";

export const UPDATE_BANKDETAILS = "UPDATE_BANKDETAILS";
export const UPDATE_BANKDETAILS_SUCCESS = "UPDATE_BANKDETAILS_SUCCESS";
export const UPDATE_BANKDETAILS_FAILED = "UPDATE_BANKDETAILS_FAILED";